module.exports = __webpack_public_path__ + "img/img_throw_6@2x_v2.260f60ed.png";